const config = {
  apiKey: "AIzaSyBup4nHiWbJ1MeSGRRTPEuLmT_6L9Dzp3g",
  authDomain: "kh07-f0399.firebaseapp.com",
  databaseURL: "https://kh07-f0399.firebaseio.com",
};

export default config;